import api from "../index";

// Get a chat by id
export const getChatById = async (id: any) => {
  return await api.get(`/chat/${id}`);
};

// Archive chat by id
export const archiveChatById = (id: any) => {
  return api.put(`/chat/archive/${id}`);
};

// Archive multiple chats
export const archiveMultipleChats = (ids: any) => {
  return api.put(`/chat/archive-multiple`, { ids });
};

// Restore chat by id
export const restoreChatById = (id: any) => {
  return api.put(`/chat/restore/${id}`);
};

// Delete chat by id
export const deleteChatById = (id: any) => {
  return api.delete(`/chat/delete/${id}`);
};

// Delete multiple chats
export const deleteMultipleChats = (ids: any) => {
  const config = {
    data: { ids },
  };
  return api.delete(`/chat/delete-multiple`, config);
};
